import TrainingImage from './TrainingImage';

export default TrainingImage;
